import { InformationAction } from 'redux/reducers/informationRecucer';

export const UPDATE_INFORMATION_VISIBILITY = 'UPDATE_INFORMATION_VISIBILITY';

export const showInformation = (visible: boolean): InformationAction => {
  return {
    type: UPDATE_INFORMATION_VISIBILITY,
    payload: { visible },
  };
};
